<template>
  <v-container class="pa-0">
    <v-dialog v-model="dialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="py-6">Xác nhận sửa</v-card-title>
        <v-card-text style="color: black">
          Thao tác này sẽ chỉnh sửa thời gian điểm danh của học sinh. Xác nhận sửa?
        </v-card-text>
        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn color="blue darken-4" text @click="close" outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-4" class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    state: Boolean,
    type: String,
  },
  mounted() {},
  computed: {},
  watch: {
    state() {
      this.dialog = true
      console.log(this.type)
    },
  },
  methods: {
    close() {
      this.dialog = false
    },

    confirm() {
      this.$emit('confirm', this.type)
      this.dialog = false
    },
  },
  filters: {},
}
</script>

<style></style>
